(function ( $ ) {

    $.fn.pinit = function( options ) {

        var defaults = {
            selector: 'img',
            ignore: '.pinit-ignore',
            class: 'pinit--wrap',
            minWidth: 200,
            minHeight: 200,
            button: '/images/pinit_icon.png'
        };

        var settings = $.extend( {}, defaults, options );
        var $images = this.is('img') ? this : this.find(settings.selector);
        // Get the user agent string
        var ios = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
        var isAbsoluteURL = new RegExp('^(?:[a-z]+:)?//', 'i');

        $images.filter(function () {
            return !$(this).is(settings.ignore);
        });

        function pinit($img){

            if($img.data('pinit') || $img.height() < settings.minHeight || $img.width() < settings.minWidth) {
                return;
            }

            var imgURL = $img.data('pinit-image') || $img.attr('src');
            var title = $img.data('pinit-title') || $('h1').text();
            var $pinButton;

            var $wrap = $('<div/>', {'class': settings.class}).css({
                'position': 'relative',
                'display': "inline-block"
            }).addClass($img[0].className);

            imgURL = isAbsoluteURL.test(imgURL) ? imgURL : window.location.protocol + "//" + window.location.hostname + imgURL;

            var shareURL = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(document.URL);
            shareURL += '&media=' + encodeURIComponent(imgURL);
            shareURL += '&description=' + encodeURIComponent(title);

            if (ios){
                $pinButton = $('<a/>', {class: 'pin-it'}).attr('href', shareURL).attr('target', '_blank');
            } else {
                $pinButton = $('<span/>', {class: 'pin-it'});

                $pinButton.on('click', function (e) {
                    window.open(shareURL, '_blank', 'width=700, height=300');

                    ga('send', 'event', 'Content', 'Share to Pinterest', $('h1').text());

                    e.preventDefault();
                });
            }

            $pinButton.hide().append('<img src="' + settings.button +'" />');

            $wrap.append($pinButton).append($img.clone().removeClass().data('pinit', true));
            $img.replaceWith($wrap);

            $pinButton.fadeIn('fast');
        }

        $images.each(function () {
            var $img = $(this);

            // Prüfen, ob das Bild schon geladen ist
            if($img[0].complete){
                pinit($img);
            } else {
                // Sonst onload abwarten
                $img.one('load', function (){
                    pinit($img);
                });
            }
        });

        return $images;
    };

}( jQuery ));